module.exports = __webpack_public_path__ + "img/+a_media_logo.0bdf231.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/+a_media_logo.svg
// module id = nd2h
// module chunks = 1